import { connect } from "react-redux"
import { Button, Card, CardBody, CardHeader, Col, Container, DatePicker, Form, FormInput, FormSelect, InputGroup, InputGroupAddon, InputGroupText, Modal, ModalBody, Row } from "shards-react"
import ReactTable from "react-table"
import React, { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { setDateForTable, setInputDate } from "../../../utils/date";
import { formatNumberAmount } from "../../../utils/general";
import Multiselect from "multiselect-react-dropdown";
import classNames from "classnames";
import { NavgationPageLocationKey } from "../../../utils/constants";
import { download_client_invoice, get_client_invoice_by_refnum, get_client_invoice_list, get_client_invoice_status_list, reset_client_invoice_details } from "../../../redux/actions/client/clientInvoice";
import { setAlert } from "../../../redux/actions/alert";

const DOWNLOAD_PDF = 'Download PDF';
function ViewClientInvoice({
    invoiceListObject,
    invoiceStatusList,

    get_client_invoice_list,
    get_client_invoice_status_list,
    download_client_invoice,
    setAlert,

    invoiceObject,
    get_client_invoice_by_refnum,
    reset_client_invoice_details,
}) {

    const initialState = {
        pageSizeOptions: [5, 10, 15, 20, 25, 30],
        pageSize: 10,
        from: '',
        to: '',
        invoiceRefNum: '',
        status: '',
        bulkAction: '',
        totalGrandTotal: 0,
    }
    const defaultStatus = [{ cat: '', key: '' }];
    //const defaultStatus = [{ cat: 'Paid', key: 'Paid' }, { cat: 'Issued', key: 'Issued' }];
    const [formData, setFormData] = useState({ status: '' })
    const [state, setState] = useState({ ...initialState });

    const [statusDropdownOptions, setStatusDropdownOptions] = useState([]);
    const [selectedValues, setSelectedValues] = useState([...defaultStatus]);
    const [totalBalanceDue, setTotalBalanceDue] = useState(0);

    const tableRef = useRef()
    const [tableData, setTableData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const history = useHistory();

    const toggle = () => {
        setOpenModal(!openModal);
        setState({ ...state, bulkAction: '' });
        setFormData({ status: '' })
    }

    const onChange = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    };

    const onCheck = (refNum) => {
        let checkedTableData = tableData.map(data => {
            if (data.refNum === refNum) {
                data.checked = !data.checked
            }

            return data;
        })

        setTableData(checkedTableData);
    }
    const checkAll = (e) => {

        let checkedTableData = tableData.map(data => {
            data.checked = e.target.checked;
            return data;
        })

        setTableData(checkedTableData);
    }
    const isAllChecked = () => {
        if (tableData.length === 0) return false

        for (let data of tableData) {
            if (!data.checked) {
                return false;
            }
        }
        return true;
    }


    // Added by nipul for parameter less flow
    function navigateToInvoice(e, refId) {
        e.preventDefault();
        history.push({
            pathname: `/client-new-invoices`,
            state: { refNum: refId }
        });
        return false;
    }

    function onContextMenuInvoiceChange(e, refId) {
        if (e.type === 'contextmenu') {
            localStorage.setItem(NavgationPageLocationKey.ClientInvoiceAddEdit, refId);
        }
    }

    function openClientInvoiceInNewTab(e, refId) {
        e.preventDefault();
        localStorage.setItem(NavgationPageLocationKey.ClientInvoiceAddEdit, refId);
        window.open('/client-new-invoices', '_blank');
    }

    const onPayNowClientInvoice = async (e, refId) => {
        //e.preventDefault();
        // let response = await get_client_invoice_by_refnum(refId);
        // if (response) {
        //     let details = invoiceObject;
        //     console.log("Do i have anything here ?", details);
        //     if (details !== undefined && Object.keys(details).length > 0) {

        //     }
        //     return false;
        // }
        //Currently navigating to edit page will be taken care later
        navigateToInvoice(e, refId);
    }

    const { pageSize, pageSizeOptions } = state;
    const tableColumns = [
        {
            Header: <input type="checkbox" checked={isAllChecked()} onClick={(e) => checkAll(e)} />,
            accessor: "action",
            minWidth: 50,
            sortable: false,
            Cell: row => <input type="checkbox" checked={row.original.checked} key={row.original.refNum} onClick={() => onCheck(row.original.refNum)} />
        },
        {
            Header: "Invoice #",
            accessor: "refNum",
            minWidth: 210,
            Cell: row => <a href="/client-new-invoices" onClick={(e) => { openClientInvoiceInNewTab(e, row.original.refNum) }}
                onContextMenu={(e) => onContextMenuInvoiceChange(e, row.original.refNum)}>
                {`INV-${row.original.refNum}`}
            </a>
        },
        {
            Header: "Invoice Date",
            accessor: "invoiceDate",
            minWidth: 240,
            Cell: row => setDateForTable(row.original.invoiceDate)
        },
        {
            Header: "Status",
            accessor: "status",
            minWidth: 210,
        },
        {
            Header: "Currency",
            accessor: "currency",
            minWidth: 200,
        },
        {
            Header: "Total",
            accessor: "total",
            minWidth: 200,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.total, 'en-US', 2, 2)}</span>
        },
        {
            Header: "Action",
            accessor: "",
            minWidth: 100,
            Cell: row =>
                <span>
                    <img src="./icons/ic_baseline-payment.svg" role="button" height="17.5" width="17.5" className="mr-2"
                        onClick={(e) => { onPayNowClientInvoice(e, row.original.refNum); }}
                    ></img>

                    <a href="/client-new-invoices" onClick={(e) => { onPayNowClientInvoice(e, row.original.refNum) }}
                        onContextMenu={(e) => onContextMenuInvoiceChange(e, row.original.refNum)}>
                        Pay Now
                    </a>
                </span>
        }
    ]

    const reset = () => {
        setState({ ...initialState })
        const selectedStatus = defaultStatus.map(status => status.key).toLocaleString()
        setSelectedValues([...defaultStatus])
        get_client_invoice_list({ from: setInputDate(initialState.from), to: setInputDate(initialState.to), clientName: initialState.clientName, invoiceRefNum: initialState.invoiceRefNum, status: selectedStatus, currency: initialState.currency });
    }

    const onSearch = (e) => {
        e.preventDefault()
        const selectedStatus = selectedValues.map(status => status.key).toLocaleString();
        let splitedRef = state.invoiceRefNum.split('-');
        const refNum = splitedRef.length > 1 ? splitedRef[1] : state.invoiceRefNum;
        get_client_invoice_list({ from: setInputDate(state.from), to: setInputDate(state.to), clientName: state.clientName, invoiceRefNum: refNum, status: selectedStatus, currency: state.currency });
    }

    const invoiceSetStatusListOptions = invoiceStatusList.map((status, i) => <option key={status + i} value={status}>{status}</option>)

    useEffect(() => {
        let invoiceStatus = invoiceStatusList.map(status => ({
            cat: status,
            key: status
        }))

        setStatusDropdownOptions([{
            cat: 'All',
            key: 'All'
        }, ...invoiceStatus])
    }, [invoiceStatusList])

    useEffect(() => {
        if (invoiceListObject !== undefined && invoiceListObject !== null && invoiceListObject?.invoiceList !== undefined) {
            setTotalBalanceDue(invoiceListObject.totalBalanceDue);
            let array = invoiceListObject?.invoiceList;
            setTableData([...array]);
        }
    }, [invoiceListObject])

    //Used to navigate to step 1 screen and need toavoid calling API
    // useEffect(() => {
    //     console.log("invoiceObject =>", invoiceObject);
    //     if (Object.keys(invoiceObject).length > 0) {
    //         let passingObj = {
    //             refNum: 0
    //             , invoiceRefNum: invoiceObject.refNum
    //             , currency: invoiceObject.currency
    //             , dueDate: invoiceObject.dueDate
    //             , balanceDue: invoiceObject.balanceDue
    //             , invoiceAmount: invoiceObject.totalAmount
    //         }
    //         history.push({
    //             pathname: `/client-invoices-payment`,
    //             state: { paymentInfo: passingObj }
    //         });
    //         reset_client_invoice_details()
    //     }
    // }, [invoiceObject])

    useEffect(() => {
        if (state.bulkAction === DOWNLOAD_PDF) {
            let selecteList = tableData.filter(data => data.checked).map(mapData => mapData.refNum);
            if (selecteList !== undefined && selecteList.length > 0) {
                //call an API
                let apiJson = { refNumList: selecteList }
                download_client_invoice(apiJson);
            }
            else {
                setAlert('Please select record(s) to download invoice', 'danger');
            }
        }
    }, [state.bulkAction])

    useEffect(() => {
        const selectedStatus = selectedValues.map(status => status.key).toLocaleString()
        get_client_invoice_list({ from: setInputDate(state.from), to: setInputDate(state.to), clientName: state.clientName, invoiceRefNum: state.invoiceRefNum, status: selectedStatus });
        get_client_invoice_status_list();
        return () => {
            reset_client_invoice_details()
        }
    }, [])

    return (<Container fluid className="main-content-container px-4 pb-4">
        <div
            className="page-header tableSearch flex-column flex-md-row py-2 d-flex justify-content-end bg-white mt-4 ">

            <div className="d-flex align-items-center p-2">
                <FormInput
                    name='invoiceRefNum'
                    value={state.invoiceRefNum}
                    onChange={onChange}
                    placeholder="Invoice #"
                />
            </div>

            <div className="d-flex align-items-center p-2">
                <Multiselect
                    hideSelectedList
                    displayValue="key"
                    placeholder={`Status: ${(selectedValues && selectedValues.length > 0 && selectedValues[0].key === 'All') ? 'All' : selectedValues.map(val => val.key).toString()}`}
                    onKeyPressFn={function noRefCheck() { }}
                    onSearch={function noRefCheck() { }}
                    onRemove={function noRefCheck(selectedOptions, item) {
                        if (item.key === 'All') {
                            setSelectedValues([])
                        } else {
                            selectedOptions = selectedOptions.filter(option => option.key !== 'All')
                            setSelectedValues([...selectedOptions])
                        }
                    }}
                    onSelect={function noRefCheck(selectedOptions, seletedItem) {
                        if (seletedItem.key === 'All') {
                            setSelectedValues([...statusDropdownOptions])
                        } else {
                            if (selectedOptions.length === statusDropdownOptions.length - 1) {
                                selectedOptions = [...statusDropdownOptions]
                            }
                            setSelectedValues([...selectedOptions])
                        }

                    }}
                    options={[
                        ...statusDropdownOptions
                    ]}
                    selectedValues={[...selectedValues]}

                    showCheckbox />
            </div>

            <div className="d-flex align-items-center p-2">
                <div className="d-flex align-items-center p-2">
                    <InputGroup
                        className={classNames("d-flex", "my-auto", "date-range")}
                    >
                        <DatePicker
                            name="from"
                            size="sm"
                            selected={state.from}
                            onChange={(date) => {
                                setState({ ...state, from: date })
                            }}
                            dateFormat='yyyy-MM-dd'
                            placeholderText="Start Date"
                            dropdownMode="select"
                            autoComplete='off'
                            className="text-center"
                        />
                        <DatePicker
                            name="to"
                            size="sm"
                            selected={state.to}
                            onChange={(date) => {
                                setState({ ...state, to: date })
                            }}
                            dateFormat='yyyy-MM-dd'
                            placeholderText="End Date"
                            dropdownMode="select"
                            autoComplete='off'
                            className="text-center"
                            popperPlacement="top-end"
                        />
                        <InputGroupAddon type="append">
                            <InputGroupText>
                                <i className="material-icons">&#xE916;</i>
                            </InputGroupText>
                        </InputGroupAddon>
                    </InputGroup>
                </div>
            </div>

            <div className="d-flex align-items-center justify-content-end p-2">
                <Button className="mx-2 py-2 my-2" size='sm' theme="accent"
                    onClick={onSearch}
                >Search</Button>
                <Button className="mx-2 py-2 my-2" size='sm' theme="accent"
                    onClick={reset}
                >Reset</Button>
            </div>
        </div>

        <Card className="tableCard p-0">
            <CardHeader className="p-0">
                <Container fluid className="file-manager__filters border-bottom">
                    <Row>
                        <Col lg="6"></Col>
                        <Col lg="3"></Col>
                        <Col lg="3">
                            <div className="float_right p-2">
                                <span className="pl-2 pr-2"> Total Balance Due: </span>
                                <span className="mr-2"> {formatNumberAmount(totalBalanceDue, 'en-US', 2, 2)}</span>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        {/* Filters :: Page Size */}
                        <Col lg="12"
                            className="file-manager__filters__rows d-flex justify-content-between">
                            <span>
                                <FormSelect
                                    size="sm"
                                    name='bulkAction'
                                    value={state.bulkAction}
                                    onChange={onChange}
                                >
                                    <option key="bulkActions0" value="">Bulk Actions</option>
                                    <option key="changeStatus1" value={DOWNLOAD_PDF}>Download PDF</option>
                                </FormSelect>
                            </span>
                            <span><span>Show</span>
                                <FormSelect
                                    size="sm"
                                    name='pageSize'
                                    value={state.pageSize}
                                    className="d-inline"
                                    onChange={onChange}
                                >
                                    {pageSizeOptions.map((size, idx) => (
                                        <option key={idx} value={size}>
                                            {size} rows
                                        </option>
                                    ))}
                                </FormSelect>
                            </span>
                        </Col>
                    </Row>
                </Container>
            </CardHeader>
            <CardBody className="p-0">
                <div className="">
                    <ReactTable
                        ref={tableRef}
                        columns={tableColumns}
                        data={tableData}
                        pageSize={Number(pageSize)}
                        showPageSizeOptions={false}
                        resizable={false}
                        noDataText="No results found"
                    />
                </div>
            </CardBody>
        </Card>
    </Container>)
}

const mapStateToProps = (state) => ({
    invoiceListObject: state.clientInvoice.invoiceListObject,
    invoiceStatusList: state.clientInvoice.invoiceStatusList,
    invoiceObject: state.clientInvoice.invoiceObject
})
export default connect(mapStateToProps, {
    get_client_invoice_list,
    get_client_invoice_status_list,
    download_client_invoice,
    setAlert,
    get_client_invoice_by_refnum,
    reset_client_invoice_details,
})(ViewClientInvoice)